import { getVisitorId, getSessionId } from './visitor-identity';
import { whenBigBrainReady } from './bigbrain-init';

export const PUBLIC_VIEW_EVENT = 'ai_app_public_view';

const RAW_APP_ID = '__VIBE_APP_ID__';
export const DEPLOY_APP_ID = String(RAW_APP_ID).includes('__VIBE_') ? undefined : Number(RAW_APP_ID) || undefined;

let hasFired = false;

export function resolveViewer(context) {
  const ctx = context ?? {};
  const rawId = ctx?.user?.id ?? ctx?.userId ?? null;
  const pulse_user_id = rawId == null || !Number.isFinite(Number(rawId)) ? null : Number(rawId);
  return {
    viewer_type: pulse_user_id != null ? 'internal' : 'external',
    is_creator: Boolean(ctx?.isCreator),
    pulse_user_id,
    account_slug: ctx?.accountSlug ?? ctx?.account?.slug,
    app_id: DEPLOY_APP_ID ?? (Number(ctx?.aiAppId ?? ctx?.appId) || 0),
  };
}

export function buildPublicViewPayload(context, win) {
  const w = win ?? (typeof window !== 'undefined' ? window : undefined);
  const nav = w?.navigator ?? {};
  const loc = w?.location ?? {};
  const doc = w?.document ?? {};

  let traffic_source;
  try {
    const params = new URLSearchParams(loc.search ?? '');
    traffic_source = params.get('utm_source') ?? params.get('kind') ?? undefined;
  } catch {
    traffic_source = undefined;
  }

  const viewer = resolveViewer(context);

  return {
    info1: String(viewer.app_id),
    info2: viewer.viewer_type,
    data: {
      app_id: viewer.app_id,
      viewer_type: viewer.viewer_type,
      is_creator: viewer.is_creator,
      pulse_user_id: viewer.pulse_user_id,
      account_slug: viewer.account_slug,
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      deployment_url: `${loc.origin ?? ''}${loc.pathname ?? ''}`,
      referrer: doc.referrer ?? '',
      landing_page: loc.pathname ?? '',
      traffic_source,
      user_agent: nav.userAgent ?? '',
    },
  };
}

export function trackPublicView(context) {
  if (hasFired) return;
  if (typeof window === 'undefined') return;
  hasFired = true;

  const payload = buildPublicViewPayload(context, window);
  whenBigBrainReady().then(() => {
    if (typeof window.BigBrain !== 'function') return;
    try {
      window.BigBrain('track', PUBLIC_VIEW_EVENT, payload);
    } catch {}
  });
}
